/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Templates/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AddAction from './AddAction/index'
import Content from './Content/index'
import DeleteConfirmation from './DeleteConfirmation/index'
import Location from './Location/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Templates({
  children,
  viewPath = "/App/Account/Content/Settings/Content/NoteTemplates/Templates"
  
}) {
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="Templates.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-Zmkxee': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Templates.Vertical:1"
  data-view-path={viewPath}
 style={{'--pl-2-Zmkxee': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-3-Zmkxee': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="Templates.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 text="Note templates"
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="medium"
 marginTop={dtSpaceXs}
 color={dtColorsNeutral500}
 text="Administer note templates below to improve efficiency, consistency and compliance."
/>
</div>
<div
  data-testid="Templates.Vertical:2"
  data-view-path={viewPath}
 style={{'--mt-4-Zmkxee': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical2}`}
>
<div
  data-testid="Templates.Horizontal:1"
  data-view-path={viewPath}
 style={{'--pl-2-Zmkxee': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-3-Zmkxee': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Horizontal1}`}
>
<Location
  viewPath={`${viewPath}/Location`}
/>
<AddAction
  viewPath={`${viewPath}/AddAction`}
/>
</div>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 theme="light"
/>
<div
  data-testid="Templates.Vertical:3"
  data-view-path={viewPath}
 style={{'--pl-2-Zmkxee': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-3-Zmkxee': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical3}`}
>
<Content
  viewPath={`${viewPath}/Content`}
/>
<DeleteConfirmation
  viewPath={`${viewPath}/DeleteConfirmation`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}